import { post, get, downloadFile, put, downloadFilePost } from 'utils/api';
import { DataResponse } from './response';

//====================================================BC01 TINH TRANG MAY MOC
export type EquipmentStatusModel = {
  // stt
  stt: number;
  id: string;
  // phân xưởng
  workShopName: string;
  workShopId: string;
  equipmentId: string;
  // tên máy
  equipmentName: string;
  // công đoạn
  stepCode: string;
  stepName: string;

  // phân loại
  type: string;
  // SL CN
  numberWorker: number;
  // LSX đang thực hiện
  workOrderCode: string;
  kssxNumber: string;
  quantity: number;
  // Mã TP/BTP
  productCode: string;
  // tên TP/BTP
  productName: string;
  startDate: string;
  // thời gian bắt đầu
  hourStart: string;
  //  thời gian kết thúc dự kiến
  hourEnd: string;
  endDate: string;

  nextWorkOrder: string;
  // trạng thái
  status: string;
  // tình trạng sử dụng
  actived?: boolean;
};
//BC01 SO DO MAT BANG PHAN XUONG
export type WorkShopEquipmentsModel = {
  workShopName: string;
  workShopEquipments: Array<dataWSE>;
};

// BC01
export type EquipmentOfBarCodeModel = {
  stt: number;
  equipmentCode: string;
  equipmentName: string;
};

//BC01 CHI TIET SO DO MAT BANG PHAN XUONG
export type dataWSE = {
  id: string;
  equipmentCode: string;
  equipmentName: string;
  type: string;
  numberWorker: number;
  workOrderCode: string;
  kssxNumber: string;
  quantity: number;
  productCode: string;
  productName: string;
  startDate: string;
  hourStart: string;
  endDate: string;
  hourEnd: string;
  nextWorkOrder: string;
  status: string;
};

//BC01 TIM KIEM
export type EquipmentStatusSearch = {
  workShopId: string | null;
  machineGroup: string[] | null;
  machineStatus: string | null;
};

// DUNG CHUNG : OBJECT WITH KEY AND VALUE
export type ListKeynValue = {
  key: string;
  value: string;
};
export type Department = {
  departmentId: string;
  departmentName: string;
};

//====================================================BC02 MODEL KE HOACH SAN XUAT
export type ProductionPlanModel = {
  equipmentName: string;
  employeeQuantity: number;
  workOrder: string;
  productName: string;
  kssxNumber: string;
  quantity: string;
  timeStart: string;
  timeStartStr: string;
  estimateComplete: string;
  estimateCompleteStr: string;
  productionGuide: string;
  productCode: string;
  releasedWorkOrders: [];
  plannedWorkOrders: Array<PlannedWorkOrdersModel>;
};
// BC02 => plannedWorkOrders
export type PlannedWorkOrdersModel = {
  kssxNumber: string;
  workOrderCode: string;
  productName: string;
  quantity: string;
  nextStep: string;
  currentEstimateComplete: string | null;
  currentEstimateCompleteStr: string | null;
};

//BC01 SAP XEP SO DO MAT BANG PHAN XUONG
export type orderIndexByEquipsArray = {
  equipCardId: string;
  orderIndex: number;
};
//BC01 SAP XEP SO DO MAT BANG PHAN XUONG
export type orderIndexByEquipsModels = {
  orderIndexByEquips: Array<orderIndexByEquipsArray>;
};

//BC01, BC02
export type workOrderInsideModel = {
  stt: number;
  kssxVote: string;
  workOrder: string;
  workOrderCardId: string;
  productName: string;
  quantityByPallet: string;
  nextStep: string;
  estimateTimeComplete: string;
  equipmentName: string;
};

// lệnh sản xuất đang chờ
export type workOrderPendingModel = {
  // số thứ tự
  stt: number;
  // khách hàng
  khachHang: string;
  // lệnh sản xuất lsx
  lsx: string;
  // id
  id: string;
  // thứ tự công đoạn
  orderIndex: string;
  // lsxId
  lsxId: string;
  // tpbtp
  tpbtp: string;
  // Công đoạn
  congDoan: string;
  // slPhatLenh
  slPhatLenh: number;
  // đơn vị tính
  dvt: string;
  // máy chuyền thực hiện
  mayChuyenThucHien: string;
  loaiLSX: string;
  ngayYeuCauCoHangIn?: string;
  ngayHangInVe?: string;
};
// lệnh sản xuất đang thực hiện
export type LsxDangThucHienModel = {
  // lệnh sản xuất đang thực hiện
  lsxDangThucHien: string;
  // số sản phẩm tờ công đoạn
  soSpToCongDoan: number;
  // số lượng sản phẩm theo lệnh sản xuất
  slspTheoLSX: number;
  // số lượng Tờ sản phẩm quy đổi
  slToSPQuyDoi: number;
  // số lượng đã ghi nhận
  slDaGhiNhan: number;
  // thời gian giao hàng
  thoiGianGiaoHang: string;
  // hướng dẫn sản xuất
  hdsx: string;
  // nguyên vật liệu sử dụng
  nvlSuDung: string;
};

export type EmployeesOfquipmentStatusReportModel = {
  id: string;
  name: string;
};

//BC02 DATA FROM API
export type EquipmentStatusReportModel = {
  barcodeName: string;
  workOrderProcessing: string;
  kssxVote: string;
  productionIns: string;
  productUsed: string;
  quantityWorker: number;
  productProcessing: string;
  productName: string;
  startTime: string;
  numberPallet: string;
  quantityOrder: number;
  quantityRecord: number;
  productPerPage: string;
  unit: string;
  status: string;
  quantityByPallet: number;
  employees: string[];
  estimateTimeComplete: string;
  workOrderPendings: workOrderInsideModel[];
  description: string;
  stepName: string;
  reasonStop: string;
};
//BC02 DATA FROM API (NEW 22/05/2023)
export type BC02 = Partial<{
  // tên máy truyền
  tenMayChuyen: string;
  // Công đoạn
  congDoan: string;
  // ghi chú
  ghiChu: string;
  // SL CN đứng ca
  soCNDungCa: number;
  // Thời gian bắt đầu
  tgBatDau: string;
  // thời gian dự kiến hoàn thành
  tgDuKienHoanThanh: string;
  //  LSX đang thực hiện
  workOrderProcessing: string;
  // trạng thái
  trangThai: string;
  // Lý do ngưng máy
  lyDoNgungMay: string;
  // nhân viên
  danhSachCongNhan: string[];
  lsxDangThucHien: LsxDangThucHienModel[];
  // lệnh sản xuất đang chờ
  lsxDangCho: workOrderPendingModel[];
  lsxDaChon: workOrderPendingModel[];
}>;

// BC02 DATA POPUP CHỌN MÁY THỰC HIỆN
export type PopUpDataDetail = {
  id: string;
  sttCongDoan: number;
  tenCongDoan: string;
  congDoan: string;
  // equipmentCardId?: string;
  // barcodeName?: string;
  barcode?: {
    barcodeName: string;
    equipmentCardId: string;
  }[];
  listBarcode?: {
    label: string;
    value: string;
  }[];
};
export type BC02PopupModel = Partial<{
  lsx: string;
  chiTiets: PopUpDataDetail[];
}>;

// BC02 DATA DROPDOWN - DANH SÁCH MÁY THEO CÔNG ĐOẠN
export type BC02DropdownModel = Partial<{
  isSuccess: boolean;
  message: string;
  data: { equipmentCardId: string; equipmentName: string }[];
}>;

//BC06 BAO CAO TONG HOP THOI GIAN HOAT DONG CUA MAY, CHUYEN SAN XUAT

export type BC06Chart = {
  type: string;
  value: number;
};

export type Paging = {
  totalCount: number;
  pageIndex: number;
  pageSize: number;
  totalPages: number;
};
export type UptimeEquipment = {
  statusName: string;
  statusCode: string;
  executionTime: number;
  percent: number;
  orderIndex: number;
};

export type SummaryReportProduction = {
  stt: number;
  id: string;
  equipmentName: string;
  equipmentGroup: string;
  ratedTime: number;
  totalUptime: number;
  uptimeEquipments: UptimeEquipment[];
};

export type DataSummaryReportProduction = {
  totalAllRatedTime: number;
  totalAllUptime: number;
  totalAllUptimeCM: number;
  totalAllPerCM: number;
  totalAllUptimeHD: number;
  totalAllPerHD: number;
  totalAllUptimeVS: number;
  totalAllPerVS: number;
  totalAllUptimeNM: number;
  totalAllPerNM: number;
  charts: BC06Chart[];
  paging: Paging;
  summaryReportProductions: SummaryReportProduction[];
};

export type BC06DataChart = {
  type: string;
  value: number;
};

//BC06 DETAILS
export type BC07DetailsData = {
  type: string;
  values: number[];
};

export type BC06Details = {
  labels: string[];
  datas: BC07DetailsData[];
};

//BC07
export interface BC07DetaileRportTimeMachine {
  reasonStopCode: string;
  reasonStopName: string;
  timeStop: number;
}

export interface BC07TimeMachineTroubled {
  stt: number;
  equipmentCardId: string;
  workShopName: string;
  equipmentGroup: string;
  equipmentName: string | null;
  totalTimeStop: number;
  detaileRportTimeMachines: BC07DetaileRportTimeMachine[];
}
export type BC07ChartDetails = {
  type: string;
  values: number[];
};

export type BC07DataChart = {
  labels: string[];
  datas: BC07ChartDetails[];
};

//BC07 DETAILS
export type TimeMachineHasTroubled = {
  stt: number;
  date: string;
  timeStart: string;
  timeEnd: string;
  hours: number | string;

  reasonStop?: any;
  description: string;
};

export type DetailTimeMachineTroubledReport = {
  workShopName: string;
  equipmentName: string;
  timeMachineHasTroubleds: TimeMachineHasTroubled[];
};
//BC08
export type BC08 = {
  stt: number;
  workShopId: string;
  equipName: string;
  productionDateStart: Date;
  productionDateEnd: Date;
  executionHour: number;
  executionMin: number;
  job: string;
  palletNumber: string;
  type: string;
  quantity: number;
  workOrderCode: string;
  productGroup: string;
  productGroupDetail: string;
  productCode: string;
  productName: string;
  workerNumber: number;
  staffs: string;
  description: string;
  soLuongGhiNhan1: number;
  dvT1: string;
  soLuongGhiNhan2: number;
  dvT2: string;
};

//BC09
export interface PalletProduction {
  palletNumber?: string;
  totalQuantity: number;
}

export interface QuantityCompleteRateStage {
  palletNumber: string;
  quantityOk: number;
  quantityNotOk: number;
}

export interface DetailCompleteRate {
  orderIndex: number;
  stepName: string;
  stepCode: string;
  percent: number;
  quantities: string[];
  quantityCompleteRateStage: QuantityCompleteRateStage[];
}

export interface BC09CompleteRateStage {
  stt: number;
  workOrderId: string;
  // mã lệnh sx
  workOrderCode: string;
  // mã TP
  productCode: string;
  // Tên TP
  productName: string;
  // Ngày ra lsx
  createWODate?: string;
  // ngày giao hàng
  deliveryDate?: string;
  // Số lượng phát lệnh
  quantityOrder: number;

  palletProductions: PalletProduction[];
  detailCompleteRates: DetailCompleteRate[];
}

//BC05
export type BC05 = {
  stt: number;
  workOrderId: string;
  woGeneral: string;
  workOrderCode: string;
  productCode: string;
  productName: string;
  plannedOutput: number;
  actualOutput: number;
  unit: string;
  percentComplete: number;
  planTime: number;
  actualTime: number;
  timeDifference: number;
};

// BC05 Details
export interface Detail {
  stepCode: string;
  plannedOutput: number;
  actualOutput: number;
  unit: string;
  percentComplete: number;
  planTime: number;
  actualTime: number;
  timeDifference: number;
}

export interface Header {
  numberPallet: string;
  woGeneral: string;
  workOrderCode: string;
  productName: string;
  quantityByPallet: number;
  quantityOrder: number;
  detail: Detail[];
}

export interface BC05Details {
  numberPallet: string;
  header: Header;
}

export interface BC05DetailsResponse {
  code: number;
  data: BC05Details[];
  message: string;
  isSuccess: boolean;
  resultsCount: number;
  recordsTotal: number;
  pagesCount: number;
}

//BC04
export interface BC04 {
  stt: number;
  productionTeam: string;
  staffName: string;
  staffCode: string;
  quantityPlan: number;
  quantityActual: number;
  percentComplete: number;
  minutesPlan: number;
  minutesActual: number;
  productivity: number;
}
export type BC04ChartDetail = {
  type: string;
  values: number[];
};

export type BC04Chart = {
  labels: string[];
  datas: BC04ChartDetail[];
};

// BC04
export interface BC04Response {
  code: number;
  data: BC04[];
  dataChart: BC04Chart;
  message: string;
  isSuccess: boolean;
  resultsCount: number;
  recordsTotal: number;
  pagesCount: number;
}

//=================================================================================================================

//BC05
export type BC05Response = {
  code: number;
  data: BC05[];
  message: string;
  isSuccess: boolean;
  resultsCount: number;
  recordsTotal: number;
  pagesCount: number;
};
// ==================================================================================================================================

//BC09 response
export interface BC09CompleteRateStageResponse {
  code: number;
  data: BC09CompleteRateStage[];
  message: '';
  isSuccess: boolean;
  resultsCount: number;
  recordsTotal: number;
  pagesCount: number;
}
//BC08
export type BC08Response = {
  code: number;
  data: BC08[];
  message: string;
  isSuccess: boolean;
  resultsCount: number;
  recordsTotal: number;
  pagesCount: number;
};
// =================================================================================================================================
//                                  BÁO CÁO MỚI
// ===================================================================================================================
// BÁO CÁO 07 (MỚI)

export interface BC07 {
  key: string;
  stt: number;
  idLSX: string;
  loaiLSX: string;
  lsx: string;
  maTPBTP: string;
  tenTPBTP: string;
  khachHang: string;
  loaiFSC: string;
  ngayRaLSX: string;
  ngayGiaoHang: string;
  ngayYeuCauCoHangIn: string;
  ghiChuTrangThaiMes: string;
  ngayDuKienHoanThanhLSX: string;
  tgThucTeHoanThanhLSX: string;
  thoiGianThucTeHTCDIn?: string;
  slPhatLenh: number;
  slHangInVeXuongTheoSanPham?: number;
  // SL hàng in về xưởng\n(Tờ)
  slHangInVeXuongTheoTo?: number;
  // SL hàng đạt công đoạn in (Tờ)
  slHangDatCongDoanInTheoTo?: number;
  // SL hàng đạt CĐ in (Sản phẩm)
  slHangDatCongDoanInTheoSanPham?: number;
  dvt: string;
  trangThaiLSX: string;
  drawCode: string;
  marquette: string;
  // Lệnh thiết kế
  matchCard?: string;
  // Tên hạng mục in
  printItem?: string;
  // Lệnh tổng hợp
  parentWorkOrderCode?: string;
  // trạng thái công đoạn
  workOrderRoutingStatus: string;
  // Số SP/Tờ/Công đoạn (Theo Routing)
  soSPToCongDoan?: number
  routings: RoutingBC07[];
}

export interface RoutingBC07 {
  thuTuCongDoan: number;
  congDoan: string;
  percentHTCongDoan: number;
  tickHTCD: string;
  nvlSuDung: string;
  hdsx: string;
  khuonKeHoach: string;
  slSanPhamDat: number;
  slSanPhamLoi: number;
  soGioSXKH: number;
  soPhutSXKH: number;
  soGioSXTT: number;
  soPhutSXTT: number;
  soGioChenhLech: number;
  soPhutChenhLech: number;
  chiTietBaoCao: ChiTietBaoCao07;
}
export interface ChiTietBaoCao07 {
  danhSachMayMoc?: string[];
  ngaySanXuat: String;
  soGioCanhMay: number;
  soPhutCanhMay: number;
  thoiGianBatDau: string;
  thoiGianKetThuc: string;
  soGioThucHien: number;
  soToTrenNhipBe: number;
  soPhutThucHien: number;
  slGhiNhan: number;
  dvtCongDoan: string;
  spToCongDoan: string;
  slGhiNhanPCS: number;
  dvT2: string;
  khuonSuDung: string;
  banVeSP: string;
  marquette: string;
  slNhanCongKeHoach: string;
  slNhanVienThucHien: number;
  nhanVienThucHien: string;
  tongGioCong: number;
  ghiChu: string;
  tyLeGhepBai: number;
  tenBarcode: string;
  // Thời gian còn lại (Tính theo sản lượng thực tế của các công đoạn sau gia công in)
  soPhutConLai2?: number;
  soGioConLai2?: number;
}

// =============================================================================
// BC08 mới
export interface BC08Model {
  stt: number;
  idLSX: string;
  // Loại lệnh sản xuất
  loaiLSX: string;
  // lệnh sản xuất
  lsx: string;
  // LSX tổng hợp
  lsxTongHop: string;
  // ghi chú lệnh sản xuất
  ghiChuLSX: string;
  // Mã trạng thái lệnh sản xuất
  trangThaiLSXCode: string;
  // Trạng thái lệnh sản xuất
  trangThaiLSX: string;
  // Ngày phất lệnh
  ngayPhatLenh: string;
  // Ngày hàng in về xương
  ngayHangInVeXuong: string;
  // ngày giao hàng
  ngayGiaoHang: string;
  // Thời gian thực tế hoàn thành lệnh
  tgThucTeHoanThanhLenh: string;
  // Khách hàng
  khachHang: string;
  // Kiểu in
  kieuIn: string;
  // loại fsc
  loaiFSC: string;
  // phân cấp sản phẩm
  phanCapSP: string;
  // nhóm sản phẩm
  nhomSP: string;
  // Nhóm sản phẩm kinh doanh
  nhomSPChiTiet: string;
  // Nhóm SP sản xuất
  nhomSPSX: string;
  // Mã sản phẩm
  maSP: string;
  // Tên sản phảm
  tenSP: string;
  // Khích thước sản phẩm
  kichThuocSP: string;
  // Khổ trải
  // Hạng mục in
  hangMucIn: string;
  khoTrai: string;
  // Số lượng phát lệnh
  slPhatLenh: number;
  // Số lượng hàng in về xưởng
  slHangInVeXuong: number;
  // số lượng hàng lỗi ở các công đoạn sản xuất
  slHangLoiCacCDSX: number;
  // Số lượng nhập kho
  sltpNhapKho: number;
  // Đơn vị tính
  dvt: string;
  // Công đoạn nhập kho
  congDoanNK: string;
  // ngày nhập kho
  ngayNhapKho: string;
  // Thời gian nhập kho thực tế
  tgThucTeNK: string;
  // tổng số lần nhập kho
  tongSoLanNK: number;
  // Số LOT
  soLOT: string;
  // Số lượng thừa thiếu so với lệnh sản xuất
  thuaThieuSoVoiLSX: number;
  // Tỷ lệ lỗi
  tyLeLoi: number;
  // Chi tiết báo cáo
  chiTietBaoCao: ChiTietBaoCao08[];
}
export interface ChiTietBaoCao08 {
  // ngày nhập kho
  ngayNK: string;
  // Thời gian nhập kho thực tế
  tgNhapKhoThucTe: string;
  // Tổng số lần nhập kho
  tongSoLanNK: number;
  // số phiếu nhập kho
  soPhieuNhapKhoMES: string;
  // Số lot
  soLOT: string;
  // Số lượng thừa thiếu so với lệnh sản xuất
  thuaThieuSoVoiLSX: number;
  // Tỷ lệ lỗi
  tyLeLoi: number;
  // Thứ tự công đoạn
  thuTuCongDoan: number;
  // Công đoạn
  congDoan: string;
  // Số lượng ghi nhận
  slGhiNhanPCS: number;
  // Số lượng đạt
  slDat: number;
  // Số lượng lỗi
  slLoi: number;
  // Đơn vị tính
  dvt: string;
  // Tỷ lệ lỗi theo công đoạn
  tyLeLoiTheoCongDoan: number;
  // Số lượng canh máy đạt
  slCanhMayDat: number;
  // Số lượng canh máy lỗi
  slCanhMayLoi: number;
  // Tổng thời gian sản xuất
  soPhutTongTGSanXuat: number;
  soGioTongTGSanXuat: number;
  // Thời gian canh máy
  soPhutTGCanhMay: number;
  soGioTongTGCanhMay: number;
  // Ghi chú ghi nhận
  ghiChuGhiNhan: string;
  // Tình trạng TP/BTP nhập kho
  tinhTrangTPBTPNhapKHo: string;
  //  Người nhập kho
  nguoiNhapKho: string;
  // Ghi chú nhập kho
  ghiChuNhapKho: string;
  // Tick hoàn thành công đoạn
  tickHoanThanhCongDoanNhapKho: string;
  // WorkOrder Completion
  workOrderCompletion: string;
}

// =============================================================================
// BC04 mới
export interface BC04Model {
  stt: number;
  ngay: string;
  // Mã nhân viên
  maNhanVien: number;
  // Tên nhân viên
  tenNhanVien: string;
  // Tổng số giờ làm việc
  soNgayLamViec: number;
  // Thời gian định mức
  tgDinhMuc: number;
  // Số lượng chi tiết hoàn thành
  slChiTietHT: number;
  // Thời gian thực tế được ghi nhận trong giờ
  soGioTrongGio: number;
  soPhutTrongGio: number;
  // Thời gian thực tế được ghi nhận ngoài giờ
  soGioNgoaiGio: number;
  soPhutNgoaiGio: number;
  // Thời gian k tham gia sản xuất
  soGioTGKhongTGSX: number;
  soPhutTGKhongTGSX: number;
  // Phần trăm thời gian thực tế định mức
  phanTramTGTTTrenKH: number;
  // Thời gian sản xuất 1 chi tiết
  soPhutTGSX1ChiTiet: number;
  soGiayTGSX1ChiTiet: number;

  children?: BC04Model[];
}
// =================================================================
// BÁO CÁO 5 MỚI
export interface BC05Model {
  bC5Responses: BC5Response[];
  lineTongCong: LineTongCong;
  charts: {
    type: string;
    value: number;
  }[];
}

export type BC5Response = Partial<{
  key: number;
  stt: number;
  equipmentCardId: string;
  title: string;
  ngay: string;
  nhomMayNhomChuyen: string;
  mayChuyen: string;
  mayMocChiTiet: string;
  charts: any[];
  tu: string;
  den: string;
  loai: string;
  loaiHoatDong: string;
  lyDoNgungMay: string;
  ghiChu: string;
  tongThoiGianDinhMuc: number;
  tongSoGioHoatDong: number;
  tongSoPhutHoatDong: number;
  tyLeHoatDong: number;
  tongSoGioHoatDongTrongGio: number;
  tongSoPhutHoatDongTrongGio: number;
  tyLeHoatDongTrongGio: number;
  tongSoGioHoatDongNgoaiGio: number;
  tongSoPhutHoatDongNgoaiGio: number;
  tyLeHoatDongNgoaiGio: number;
  tongSoGioNgungMay: number;
  tongSoPhutNgungMay: number;
  tyLeNgungMay: number;
  tongSoGioTrong: number;
  tongSoPhutTrong: number;
  tyLeTrong: number;
  tongThoiGianTheoGio: number;
  tongThoiGianTheoPhut: number;
}>;

export interface LineTongCong {
  tongThoiGianDinhMuc: number;
  tongSoGioHoatDong: number;
  tongSoPhutHoatDong: number;
  tyLeHoatDong: number;
  tongSoGioHoatDongTrongGio: number;
  tongSoPhutHoatDongTrongGio: number;
  tyLeHoatDongTrongGio: number;
  tongSoGioHoatDongNgoaiGio: number;
  tongSoPhutHoatDongNgoaiGio: number;
  tyLeHoatDongNgoaiGio: number;
  tongSoGioNgungMay: number;
  tongSoPhutNgungMay: number;
  tyLeNgungMay: number;
  tongSoGioTrong: number;
  tongSoPhutTrong: number;
  tyLeTrong: number;
  tongThoiGianTheoGio: number;
  tongThoiGianTheoPhut: number;
}

// =====================================================X===================X=======================X================================
// =====================================================X===================X=======================X================================

//BC07
export type TimeMachineTroubledReportRespone = {
  code: number;
  data: BC07TimeMachineTroubled[];
  dataChart: BC07DataChart;
  message: string;
  isSuccess: boolean;
  resultsCount: number;
  recordsTotal: number;
  pagesCount: number;
};
//BC07 DETAILS
export type DetailTimeMachineTroubledReportResponse = {
  code: number;
  data: DetailTimeMachineTroubledReport;
  dataChart: any;
  message: string;
  isSuccess: boolean;
  resultsCount: number;
  recordsTotal: number;
  pagesCount: number;
};
//BC06 details response
export type BC06DetailsResponse = {
  code: number;
  data: BC06Details;
  message: string;
  isSuccess: boolean;
  resultsCount: number;
  recordsTotal: number;
  pagesCount: number;
};
//BC06 BAO CAO TONG HOP THOI GIAN HOAT DONG CUA MAY, CHUYEN SAN XUAT
export type SumaryProductionReportResponse = {
  code: number;
  data: DataSummaryReportProduction;
  dataChart: BC06DataChart[];
  message?: any;
  isSuccess: boolean;
  resultsCount: number;
  recordsTotal: number;
  pagesCount: number;
};

// BC 02
export type EquipmentStatusReportResponse = {
  code: number;
  data: EquipmentStatusReportModel;
  message: string;
  isSuccess: boolean;
  resultsCount: number;
  recordsTotal: number;
  pagesCount: number;
};
// BC01 SO DO MAT BANG PHAN XUONG
export type WorkShopEquipmentsResponse = {
  data: Array<WorkShopEquipmentsModel>;
  message: string;
  isSuccess: boolean;
  recordsTotal: number;
  resultsCount: number;
  pagesCount: number;
};
//BC01 BAO CAO TINH TRANG MAY MOC
export type EquipmentStatusResponse = {
  data: Array<EquipmentStatusModel>;
  message: string;
  isSuccess: boolean;
  recordsTotal: number;
  resultsCount: number;
  pagesCount: number;
};

// DUNG CHUNG : KEY AND VALUE
export type ListKeynValueResponse = {
  data: Array<ListKeynValue>;
  message: string;
  isSuccess: boolean;
};
export type DepartmentResponse = {
  data: Array<Department>;
  message: string;
  isSuccess: boolean;
};

//data responese Danh sach may moc cua barcode may moc
//BC01
export type ListEquipmentOfBarCodeResponese = {
  code: number;
  data: Array<EquipmentOfBarCodeModel>;
  message: string;
  isSuccess: boolean;
  recordsTotal: number;
  resultsCount: number;
  pagesCount: number;
};

// =========================== Báo cáo 3 ==============================
// ====================================================================
// Báo cáo cảnh báo tiến độ đơn hàng BC03
export type BC03 = Partial<{
  stt: number;

  idLSX: string;

  loaiLSX: string;
  // Lệnh sản xuất tổng hợp
  lsxTongHop: string;
  // Ghép bài/Lệnh TK
  ghepBaiLTK: string;
  // Khách hàng
  khachHang: string;
  // Lệnh sản xuất
  lsx: string;
  soCode: string;
  soLuongYeuCauSXSO: number;
  soDate: string;
  ngayYeuCauNhapKho: string;

  ngayRaLSX: string;

  ngayYeuCauCoHangIn: string;

  maTPBTP: string;

  tenTPBTP: string;

  slPhatLenh: number;

  slThucTeCDC: number;

  dvt: string;

  tyLeHoanThanhLSX: number;
  // Tỉ lệ chênh lệch số lượng wo/so
  tiLeChenhLech?: number;
  soGioConLai: number;

  soPhutConLai: number;
  soGioConLai2: number;

  soPhutConLai2: number;

  soGioSXTheoKH: number;

  soPhutSXTheoKH: number;

  soGioDaSXKeHoach: number;

  soPhutDaSXKeHoach: number;

  soGioDaSXThucTe: number;

  soPhutDaSXThucTe: number;

  tgConLai: string;

  ngayHoanThanhSXDuKien: string;

  ngayGiaoHang: string;

  trangThaiLSXCode: string;

  trangThaiLSX: string;

  ghiChuTrangThaiMes: string;

  mauTienDoDonHang: string;

  exec: number;

  listRouting: ListRouting[];

  chiTietBaoCao: ChiTietBaoCao[];

  // Thời gian trễ tiến độ
  soGioTreTienDo: number;
  soPhutTreTienDo: number;

  //==== row tổng==============
  // Thời gian sx kế hoạch
  tongSoGioSXKH: number;
  tongSoPhutSXKH: number;
  // Thời gian sản xuất thực tế
  tongSoGioSXTT: number;
  tongSoPhutSXTT: number;
  // thời gian còn lại kế hoạch
  tongSoGioConLaiKeHoach: number;
  tongSoPhutConLaiKeHoach: number;
  // Thời gian còn lại thực tế
  tongSoGioConLaiThucTe: number;
  tongSoPhutConLaiThucTe: number;
  tongSoGioTreTienDo: number;
  tongSoPhutTreTienDo: number;

  quantity: number;
  buHaoWO: number;
}>;

export type ListRouting = {
  maCongDoan: string;
  tenCongDoan: string;
  thuTuCongDoan: number;
  mau: string;
  tiLeHoanThanh: number;
  tiLeHoanThanhNew: string;
  isYellow: boolean;
  equipments: any[];
};

export type ChiTietBaoCao = Partial<{
  congDoan: string;
  dvT2: string;
  slConLai: number;
  slKeHoach: number;
  slThucTe: number;
  slThucTeDat: number;
  soGioChenhLech: number;
  soGioConLaiKeHoach: number;
  soGioSXKH: number;
  soGioSXTT: number;
  soPhutChenhLech: number;
  soPhutConLaiKeHoach: number;
  soPhutSXKH: number;
  soPhutSXTT: number;
  thuTuCongDoan: string | number;
  tickHTCD: string;
  tyLeChenhLech: number;
  tyLeHoanThanh: number;
  soGioConLai3: number;
  soPhutConLai3: number;

  // Thời gian trễ tiến độ
  soGioTreTienDo: number;
  soPhutTreTienDo: number;
}>;

// ====================================== BC11 ==============================
export interface WoQCProductionModel {
  stt: number;
  workOrderId: string;
  workOrderCode: string;
  productCode: string;
  productName: string;
  orderIndex: number;
  stepCode: string;
  stepName: string;
  productPerPage: number;
  orderQuantity: number;
  quantityOKDelivery: number;
  unit: string;
  quantityOKByStep1: number;
  quantityOKByStep2: number;
  quantityNotOKByStep1: number;
  quantityNotOKByStep2: number;
  percentLoss?: string;
  resultQC?: string;
  isLast: boolean;
}

//  Báo cáo QC công đoạn sản xuất theo chỉ tiêu kiểm tra
export type DetailTestTargetProduction = {
  qcTime: string;
  qcBy: string;
  quantitySample: number;
  quantityOK: number;
  quantityNotOK: number;
  unit: string;
  errorName?: string;
  toKnow?: string;
  reason?: string;
  description: string;
  conclusion: string;
  conclusionName: string;
};

export type TestTargetProduction = {
  numberPallet: string;
  workOrderCode: string;
  stepCode: string;
  testTargetName: string;
  detailTestTargetProduction: DetailTestTargetProduction[];
};

export interface QcProductionReport {
  commandQCCode: number;
  testTargetId: string;
  qcTime: string;
  ngayPhatLenh: string;
  workOrderCode: string;
  productCodeAndName: string;
  stepCode: string;
  stepCodeAndName: string;
  quantityProduction?: number;
  testTargetName: string;
  quantitySample: number;
  quantityOK: number;
  quantityNotOK: number;
  unit: string;
  kssxNumber: string;
  kssxIndex: number;
  kssxnUmberIndex: string;
  errorName: string;
  description: string;
  resultQC: string;
  testTargetProduction: TestTargetProduction;
}
export interface QCProductionModel {
  resultQC: string;
  resultQCName: string;
  qcProductionReports: QcProductionReport[];
}
// ==========================================================================

//===============BC10====================================================================
// Báo cáo LSX đã hoàn thành
export interface DetailWorkOrderComplete {
  orderIndex: number;
  stepName: string;
  totalQuantity: number;
  quantityOk: number;
  quantityNotOk: number;
  unit: string;
}

export interface WoCompleteModel {
  stt: number;
  workOrderId: string;
  lsx: string;
  printDate: string;
  orderDate: string;
  customer?: string;
  productGroup: string;
  productGroupDetail: string;
  productStatus?: string;
  productCode: string;
  productName: string;
  productSize?: string;
  productSpreadSize: string;
  quantityProduction: number;
  quantityPrint: number;
  quantityErr: number;
  quantityReceive: number;
  unit: string;
  stepReceive: string;
  lotNumber: string;
  receiveDate?: string;
  excessShortageLSX: number;
  percentErr: number;
  detailWorkOrderCompletes: DetailWorkOrderComplete[];
  infoReceives: InfoReceives[];
  description: string;
}

export interface InfoReceives {
  lotNumber: string;
  stepName: string;
  quantity: number;
  unit?: string;
  expiryDate: string;
  receiveDate: string;
  receiveBy?: string;
}

// ======================================================================================

export interface IReportService {
  //BC01 tinh trang may moc
  getEquipmentStatusReport(data: any): Promise<EquipmentStatusResponse>;
  //BC01 DROPDOWN danh sach phan xuong
  getListWorkShop(): Promise<ListKeynValueResponse>;
  //BC01 export file excel    DEADLINK!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  exportExcelBC11(): Promise<void>;
  //BC01 so do mat bang phan xuong
  getWorkShopEquipments(
    WorkShopId?: string | null,
    MachineGroup?: string[] | null,
    MachineStatus?: string | null,
    EuipmentName?: string[] | null,
    Actived?: boolean | null,
    equipmentCardIds?: string[]
  ): Promise<WorkShopEquipmentsResponse>;
  //BC01 DROPDOWN danh sach to san xuat
  getDropdownDepartment(WorkShopId?: string): Promise<ListKeynValueResponse>;
  //BC01 lay danh sach may moc cua barcode
  getListEquipmentOfBarCode(EquipmentCardId: string): Promise<ListEquipmentOfBarCodeResponese>;
  //BC01 cap nhap ten cua danh sach may moc
  updateBarCodeNameEquip(data: object): Promise<DataResponse<void>>;
  //BC01 cap nhat vi tri cua may moc trong so do
  updateIndexBarcode(data: object): Promise<DataResponse<void>>;
  //BC01 DROPDOWN danh sach trang thai
  getListEquimentStatus(): Promise<ListKeynValueResponse>;
  //BC01 DROPDOWN danh sach nhom may moc
  // danh sach ten may moc
  getListDropdownEquipmentName(key: string): Promise<ListKeynValueResponse>;
  getListGroupEquip(listId: string[]): Promise<ListKeynValueResponse>;

  // =====================================================================================================
  // =====================================================================================================
  // xuất file excel
  exportExcelBC01(data: object): Promise<void>;
  //BC02 ke hoach san xuat : lay theo equipmentCardId
  getEquipmentStatusById(equipmentCardId?: any): Promise<EquipmentStatusReportResponse>;
  //BC02 danh sach may - pop up ke hoach san xuat
  getListEquipCard(): Promise<ListKeynValueResponse>;
  // Get Data trong BC02
  getBC02(data: object): Promise<DataResponse<BC02>>;
  // export data bc02
  exportDataBC02(data: object): Promise<void>;
  // BC02 lấy data để hiển thị trong pop up
  getDataPopupBC02(WorkOrderId: string): Promise<DataResponse<BC02PopupModel>>;
  // BC02 dropdown danh sách máy theo công đoạn
  getDataDropDown(stepCode: string, equipmentName?: string): Promise<BC02DropdownModel>;
  //BC02 cap nhat the treo lsx cho barcode may
  updateWoCard(data: object): Promise<DataResponse<void>>;
  // save chọn máy thực hiện
  saveChooseEquipment(data: object): Promise<DataResponse<void>>;
  // Sắp xếp danh sách lsx đang thực hiện
  sortRowBC02Selected(data: object): Promise<DataResponse<void>>;

  // =====================================================================================================
  // =====================================================================================================
  //BC06 BAO CAO TONG HOP THOI GIAN HOAT DONG CUA MAY, CHUYEN SAN XUAT
  sumaryProductionReport(data: object): Promise<SumaryProductionReportResponse>;
  //BC06 details
  getBC06Details(equipId: string, fromTime: string, toTime: string): Promise<BC06DetailsResponse>;
  // =====================================================================================================
  // =====================================================================================================
  // BC03
  getDataBC03(data: object): Promise<DataResponse<Array<BC03>>>;
  // xuất excel bc03
  exportExcelBC03(data: object): Promise<void>;
  // =====================================================================================================
  // =====================================================================================================
  //BC07
  getBC07TimeMachineTroubledReport(data: any): Promise<TimeMachineTroubledReportRespone>;
  //BC07 DETAILS
  getBC07DetailTimeMachineTroubledReport(
    EquipmentCardId: string,
    FromTime?: string,
    ToTime?: string,
  ): Promise<DetailTimeMachineTroubledReportResponse>;
  //BC07 list equiment name
  getBC07ListEquipcard(data: object): Promise<ListKeynValueResponse>;

  //---BC08-------------------------------------------------------------------------
  getBC08(data: object): Promise<BC08Response>;
  //--bc09-------------------------------------------------------------------------
  getBC09CompleteRateStage(data: object): Promise<BC09CompleteRateStageResponse>;
  getDropdownWo(woCode: string): Promise<ListKeynValueResponse>;
  // ======================================================================================================================
  //                                          BÁO CÁO MỚI
  // ======================================================================================================================
  // BC07 API get data báo cáo 07
  // Báo cáo 7 mới
  getDataBC07(data: object): Promise<DataResponse<Array<BC07>>>;
  // xuất file excel
  exportExcelBC07(data: object): Promise<void>;
  // ==========================================================================================
  // Báo cáo 08 mới
  // lấy data báo cáo mới
  getDataBC08(data: object): Promise<DataResponse<Array<BC08Model>>>;
  // xuất file excel
  exportExcelBC08(data: object): Promise<void>;

  // báo cáo 9
  exportExcelBC09(data: object): Promise<void>;
  // ==========================================================================================
  // Báo cáo 04 mới
  // lấy data báo cáo mới
  getDataBC04(data: object): Promise<DataResponse<Array<BC04Model>>>;
  // xuất file excel
  exportExcelBC04(data: object): Promise<void>;
  // ==========================================================================================
  // Báo cáo 05 mới
  // lấy data báo cáo mớI
  getDataBC05(data: object): Promise<DataResponse<BC05Model | undefined>>;
  // xuất file excel
  exportExcelBC05(data: object): Promise<void>;
  // ============================X=========X============X=========X=======================================================
  // ============================X=========X============X=========X=======================================================
  //------BC11----------------------------------------------------------------
  // Báo cáo lệnh sản xuất QC công đoạn sản xuất theo chỉ tiêu kiểm tra
  getListQCProduction(data: any): Promise<DataResponse<Array<WoQCProductionModel>>>;
  // Báo cáo QC công đoạn sản xuất theo chỉ tiêu kiểm tra
  getDetailQCProduction(woCode: string, stepCode: string): Promise<DataResponse<Array<QCProductionModel>>>;
  //--------------------------------------------------------------------------
  //-----BC10----------------------------------------------------------------
  getWoComplete(data: any): Promise<DataResponse<Array<WoCompleteModel>>>;
  //--------------------------------------------------------------------------
  // BC05
  getBC05(data: object): Promise<BC05Response>;
  //BC05 details
  getBC05Details(WorkOrderId: string): Promise<BC05DetailsResponse>;
  //BC04
  getBC04(data: object): Promise<BC04Response>;
  // BC04 tổ sản xuất
  getListDepartment(): Promise<DepartmentResponse>;
}

export function createReportService(): IReportService {
  return {
    //BC01 BAO CAO TINH TRANG MAY MOC
    getEquipmentStatusReport: async (data: any): Promise<EquipmentStatusResponse> => {
      return (await post(`MasterData/Equipment/equipment-status-report`, data)).data;
    },
    //BC01 LAY DANH SACH PHAN XUONG
    getListWorkShop: async (): Promise<ListKeynValueResponse> => {
      return (await get(`MasterData/Common/list-dropdown-workshop`)).data;
    },
    //BC11: EXPORT EXCEL
    exportExcelBC11: async () => {
      await downloadFile(`Report/ReportMES/export-excel-report-status-equipment`);
    },
    //BC01 diagram so do mat bang phan xuong
    getWorkShopEquipments: async (
      WorkShopId,
      MachineGroup,
      MachineStatus,
      EuipmentName,
      Actived,
      equipmentCardIds
    ): Promise<WorkShopEquipmentsResponse> => {
      return (
        await post(`MasterData/Equipment/workshop-plane`, {
          workShopId: WorkShopId,
          machineGroup: MachineGroup,
          equipmentList: EuipmentName,
          machineStatus: MachineStatus,
          actived: Actived,
          equipmentCardIds: equipmentCardIds
        })
      ).data;
    },
    // BC01 DANH SACH TO SAN XUAT
    getDropdownDepartment: async (WorkShopId?): Promise<ListKeynValueResponse> => {
      return (await get(`MasterData/Common/list-dropdown-department${WorkShopId ? `?workShopId=${WorkShopId}` : ``}`))
        .data;
    },
    // LAY DANH SACH MAY MOC CUA BARCODE
    getListEquipmentOfBarCode: async (EquipmentCardId): Promise<ListEquipmentOfBarCodeResponese> => {
      return (await get(`MES/EquimentRecord/get-equipment-by-barcode?EquipmentCardId=${EquipmentCardId}`)).data;
    },
    //BC01 SUA TEN BARCODE
    updateBarCodeNameEquip: async (data): Promise<DataResponse<void>> => {
      return (await put(`MES/EquimentRecord/update-barcode-name-equip`, data)).data;
    },
    //BC01 THAY DOI VI TRI BARCODE
    updateIndexBarcode: async (data): Promise<DataResponse<void>> => {
      return (await put(`MES/EquimentRecord/update-oi-equipcard`, data)).data;
    },
    //BC01 DANH SACH TRANG THAI
    getListEquimentStatus: async (): Promise<ListKeynValueResponse> => {
      return (await get(`MasterData/Common/list-status-equip`)).data;
    },
    // DANH SACH NHOM MAY MOC
    getListGroupEquip: async (listId: string[]): Promise<ListKeynValueResponse> => {
      return (await post(`MasterData/Common/list-group-equip`, listId)).data;
    },
    // Danh sach ten may moc
    getListDropdownEquipmentName: async (key: string): Promise<ListKeynValueResponse> => {
      return (await get(`MasterData/Common/list-dropdown-equipment-name${key ? '?workShopId=' + key : ''}`)).data;
    },
    // BC01 -> BC02 XEM CHI TIET MOT MAY MOC
    getEquipmentStatusById: async (equipID: any): Promise<EquipmentStatusReportResponse> => {
      return (await post(`Report/EquipmentReport/equipment-status-report`, equipID)).data;
    },

    // =====================================================================================================================
    // =====================================================================================================================
    //BC02 LAY DANH SACH TEN MAY TRONG CHINH SUA CHI TIET
    getListEquipCard: async (): Promise<ListKeynValueResponse> => {
      return (await get(`Report/EquipmentReport/list-equipcard`)).data;
    },
    //BC02 LAY DANH SACH TEN MAY TRONG CHINH SUA CHI TIET (NEW)
    getBC02: async (data) => {
      return (await post(`BC/get-data-bc2`, data)).data;
    },
    // export data bc02
    exportDataBC02: async (data) => {
      await downloadFilePost(`BC/export-excel-bc2`, data);
    },
    getDataPopupBC02: async (WorkOrderId) => {
      return (await get(`BC/get-extensions-bc2?${WorkOrderId ? `WorkOrderId=${WorkOrderId}` : ''}`)).data;
    },

    getDataDropDown: async (stepCode, equipmentName) => {
      return (
        await get(
          `BC/list-equipment-by-step?${stepCode ? `StepCode=${stepCode}&` : ''}${equipmentName ? `EquipmentName=${equipmentName}` : ''
          }`,
        )
      ).data;
    },
    saveChooseEquipment: async (data) => {
      return (await post(`BC/choose-ex-equipment`, data)).data;
    },

    // Sắp xếp lsx đang thực hiện báo cáo 02
    sortRowBC02Selected: async (data) => {
      return (await post(`BC/order-by-wo`, data)).data;
    },

    //BC02 CHINH SUA DANH SACH MAY
    updateWoCard: async (data): Promise<DataResponse<void>> => {
      return (await put(`Report/EquipmentReport/update-wocard`, data)).data;
    },
    // =====================================================================================================================
    // =====================================================================================================================
    //BC06 BAO CAO TONG HOP THOI GIAN HOAT DONG CUA MAY, CHUYEN SAN XUAT
    sumaryProductionReport: async (data): Promise<SumaryProductionReportResponse> => {
      return (await post(`Report/EquipmentReport/summary-production-report`, data)).data;
    },
    //bc06 details
    getBC06Details: async (equipId, fromTime, toTime): Promise<BC06DetailsResponse> => {
      return (
        await get(
          `Report/EquipmentReport/barchart-summary-production?EquipmentCardId=${equipId}&FromTime=${fromTime}&ToTime=${toTime}`,
        )
      ).data;
    },
    // BC03
    getDataBC03: async (data) => {
      return (await post(`BC/get-data-bc3`, data)).data;
    },
    exportExcelBC03: async (data: object) => {
      await downloadFilePost(`BC/export-excel-bc3`, data);
    },
    exportExcelBC01: async (data: object) => {
      await downloadFilePost(`MasterData/Equipment/export-bc1`, data);
    },
    // ===========================================================================
    // bc07
    getBC07TimeMachineTroubledReport: async (data): Promise<TimeMachineTroubledReportRespone> => {
      return (await post(`Report/EquipmentReport/time-machine-troubled-report`, data)).data;
    },
    // bc07
    getBC07DetailTimeMachineTroubledReport: async (
      EquipmentCardId,
      FromTime,
      ToTime,
    ): Promise<DetailTimeMachineTroubledReportResponse> => {
      return (
        await get(
          `Report/EquipmentReport/detail-time-machine-troubled-report?EquipmentCardId=${EquipmentCardId}${FromTime ? '&FromTime=' + FromTime : ''
          }${ToTime ? '&ToTime=' + ToTime : ''}`,
        )
      ).data;
    },
    // bc07
    getBC07ListEquipcard: async (data): Promise<ListKeynValueResponse> => {
      return (await post(`Report/EquipmentReport/list-equipcard`, data)).data;
    },
    // ---------------------------------------------------------------------------------------------------------------------
    //BC08
    getBC08: async (data: object) => {
      return (await post(`Report/ReportMES/production-activities-equipment`, data)).data;
    },
    //BC09
    getBC09CompleteRateStage: async (data: object) => {
      return (await post(`Report/ReportMES/complete-rate-stage`, data)).data;
    },
    //bc09
    getDropdownWo: async (woCode: string) => {
      return (await get(`MasterData/Common/get-dropdown-wo${woCode !== '' ? '?keyWord=' + woCode : ''}`)).data;
    },
    // =============================================================================================================================
    //                                                  BÁO CÁO MỚI
    // BC07 API get data báo cáo 07
    getDataBC07: async (data: object) => {
      return (await post(`BC/get-data-bc7`, data)).data;
    },
    exportExcelBC07: async (data: object) => {
      await downloadFilePost(`BC/export-excel-bc7`, data);
    },

    // BC08 API get data báo cáo 08
    getDataBC08: async (data: object) => {
      return (await post(`BC/get-data-bc8`, data)).data;
    },
    // xuất excel bc08
    exportExcelBC08: async (data: object) => {
      await downloadFilePost(`BC/export-excel-bc8`, data);
    },


    // báo cáo 09
    exportExcelBC09: async (data: object) => {
      await downloadFilePost(`Report/ReportMES/export-excel-production-activities-equipment`, data);
    },
    // ---------------------------------------------------------------------------
    // BÁO CÁO 04
    getDataBC04: async (data: object) => {
      return (await post(`BC/get-data-bc4`, data)).data;
    },
    exportExcelBC04: async (data: object) => {
      await downloadFilePost(`BC/export-excel-bc4`, data);
    },

    // Báo cáo 5
    getDataBC05: async (data: object) => {
      return (await post(`BC/get-data-bc5`, data)).data;
    },
    exportExcelBC05: async (data: object) => {
      await downloadFilePost(`BC/export-excel-bc5`, data);
    },

    // ========================================X=====================================X==============================================
    //-------BC11---------------------------------------------------
    // Báo cáo lệnh sản xuất QC công đoạn sx theo chỉ tiêu kiểm tra
    getListQCProduction: async (data: any) => {
      return (await post(`Report/ReportMES/wo-qcproduction-report`, data)).data;
    },
    // Báo cáo QC công đoạn sản xuất theo chỉ tiêu kiểm tra
    getDetailQCProduction: async (woCode: string, stepCode: string) => {
      return (await get(`Report/ReportMES/qcproduction-report?WorkOrderCode=${woCode}&StepCode=${stepCode}`)).data;
    },
    // -----BC10------------------------------------------------------
    getWoComplete: async (data: any) => {
      return (await post(`Report/ReportMES/wo-complete`, data)).data;
    },
    //----------------------------------------------------------------

    // BC05
    getBC05: async (data: object) => {
      return (await post(`Report/ReportMES/output-actual-production`, data)).data;
    },
    // BC05 details
    getBC05Details: async (WorkOrderId: string) => {
      return (await get(`Report/ReportMES/detail-output-actual-production?WorkOrderId=${WorkOrderId}`)).data;
    },
    //BC04
    getBC04: async (data: object) => {
      return (await post(`Report/ReportMES/production-and-productivity`, data)).data;
    },
    // BC04 tổ sản xuất
    getListDepartment: async () => {
      return (await get(`MasterData/Department/list-department`)).data;
    },
  };
}
